export default {
  title: 'Nous joindre',
  customerServiceTitle: 'Service à la clientèle',
  headOfficeTitle: 'Siège social',
  technicalSupportTitle: 'Soutien technique*',
  advisorsTitle: 'Conseillers',
  openingHours: 'Heures d\'ouverture',
  telephone: 'Téléphone',
  fax: 'Télécopieur',
  email: 'Courriel*',
  emailPrompt: '*Les échanges par courriel ne sont pas un moyen sécurisé de partager de l\'information.',
  agency: 'Agence',
  agencyEmail: 'Courriel de l\'agence*',
  tollFree: 'Sans frais :',
  telephoneLocal: 'Téléphone :',
};
